import type { IntlShape } from 'react-intl'

export function formatTourV2SnapshotRoom(room: App.Tours.V2OfferSnapshotRoom, intl: IntlShape) {
  const {
    adultCount,
    childCount,
  } = room

  const parts: Array<string> = []
  if (adultCount) {
    parts.push(intl.formatMessage(
      {
        id: 'Q00KGGTUZr2nZMDhBIfN',
        defaultMessage: '{adultCount, plural, one {# adult} other {# adults}}',
        description: 'Adult occupancy text for tour v2 room snapshot in the tours section',
      },
      { adultCount },
    ))
  }
  if (childCount) {
    parts.push(intl.formatMessage(
      {
        id: 'osncyOK7bv21ibDfAOvx',
        defaultMessage: '{childCount, plural, one {# child} other {# children}}',
        description: 'Child occupancy text for tour v2 room snapshot in the tours section',
      },
      { childCount },
    ))
  }

  return parts.join(', ')
}
